import React, { useReducer } from "react";
import RegistroContext from "./registroContext";
import RegistroReducer from "./registroReducer";
import clienteAxios from "../../service/axios";
import { WidType } from "types/widget"


import {
  OBTENER_REGISTROS,
  LIMPIAR_REGISTROS,
  OBTENER_REGISTROS_HISTORICO,
  LIMPIAR_REGISTROS_HISTORICO,
  REGISTROS_ERROR,
  ACTUALIZAR_FECHAS,
} from "types/context";

  const RegistroState = (props) => {
    let hasta= new Date() 
    hasta.setHours(23);
    hasta.setMinutes(59);
    hasta.setSeconds(59);
    let desde= new Date() 
    desde.setHours(0);
    desde.setMinutes(0);
    desde.setSeconds(0);
  const initialState = {
    registros: {}, // contiene los datos de las lecturas de todos lo disp del cliente y sus variables
    registrosHistoricos:[],
    mensaje: null,
    fechaDesde: desde,
    fechaHasta: hasta
  };

  const [state, dispatch] = useReducer(RegistroReducer, initialState);
  // Obtener los Registros
  // Recibe un arreglo de dispositivos(nros de serie) y va recuperando sus lecturas para cargar el estado
  const obtenerRegistros = async (dispositivos, num, nSerie) => {
  // limpio los registros del estado para cargar los nuevos
    dispatch({
      type: LIMPIAR_REGISTROS,
      payload: null,
    });
    dispatch({
      type: LIMPIAR_REGISTROS_HISTORICO,
      payload: null,
    });
    try {
      let datos = {};
      //recorro los
      let disp={}
      let i=0;
      if (nSerie===null){
      for (i in dispositivos) {
        disp.numeroSerie = dispositivos[i].variables[0].dispositivo.numeroSerie;
        if (!datos.hasOwnProperty(disp.numeroSerie)) {
          datos[disp.numeroSerie] = {};
        }
        let limit; 
        if (dispositivos[i].tipo===WidType.Pasos && num === null) {limit = 50}
        if (dispositivos[i].tipo===WidType.LMove && num === null) {limit = 35}
        if (dispositivos[i].tipo===WidType.Linea && num === null) {limit = 50}
        if (dispositivos[i].tipo===WidType.Barras && num === null) {limit = 50}
        if (dispositivos[i].tipo===WidType.Bateria) {limit = 200}
        
        if (num === null && dispositivos[i].tipo!==WidType.Barras 
          && dispositivos[i].tipo!==WidType.Linea && dispositivos[i].tipo!==WidType.Pasos 
          && dispositivos[i].tipo!==WidType.Bateria){ limit = 1} 
        // pongo limite 60 para pruebas
        //Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString()
        if (num === null){
          const resultado2 = await clienteAxios.get(
          `/registros/historico/${disp.numeroSerie}`,
          {
            params: {
              limite:limit,
              /* fechaDesde: state.fechaDesde
                ? new Date(
                    state.fechaDesde.getTime() -
                      state.fechaDesde.getTimezoneOffset() * 60000
                  ).toISOString()
                : null,
              fechaHasta: state.fechaHasta
                ? new Date(
                    state.fechaHasta.getTime() -
                      state.fechaHasta.getTimezoneOffset() * 60000
                  ).toISOString()
                : null,*/
            }, 
          }
        );
        // armo el registro y lo inserto
        resultado2.data.registros.forEach((reg) => {
          reg.lecturas.forEach((lectura) => {
            if (lectura.valor) {
              if (!datos[disp.numeroSerie].hasOwnProperty(lectura.variableId)) {
                //
                datos[disp.numeroSerie][lectura.variableId] = {};
                datos[disp.numeroSerie][lectura.variableId]["valores"] = {};
                datos[disp.numeroSerie][lectura.variableId]["nombreVariable"] =
                  lectura.nombreVariable;
                datos[disp.numeroSerie][lectura.variableId]["id"] =
                  lectura["_id"];
                datos[disp.numeroSerie][lectura.variableId]["unidadMedida"] =
                  lectura["unidadMedida"];
                datos[disp.numeroSerie][lectura.variableId]["numeroSerie"] =
                  reg["numeroSerie"];
                datos[disp.numeroSerie][lectura.variableId][
                  "ultima_lectura"
                ] = {
                  auditoria: reg.auditoria,
                  valor: lectura.valor,
                };
              }
              //
              datos[disp.numeroSerie][lectura.variableId]["valores"][
                reg.auditoria
              ] = lectura.valor;
            }
          });
        });
      }
      }}
      else{
        if (dispositivos) { 
            disp.numeroSerie = dispositivos[i].variables[0].dispositivo.numeroSerie;}
          else {
            disp.numeroSerie= nSerie;
          }
          if (!datos.hasOwnProperty(disp.numeroSerie)) {
            datos[disp.numeroSerie] = {};
          }
          if (num !== null){
            const resultado = await clienteAxios.get(
              `/registros/historico/${nSerie}`,
              {
                params: {
                  limite:num,
                  fechaDesde: state.fechaDesde
                    ? new Date(
                        state.fechaDesde.getTime() -
                          state.fechaDesde.getTimezoneOffset() * 60000
                      ).toISOString()
                    : null,
                  fechaHasta: state.fechaHasta
                    ? new Date(
                        state.fechaHasta.getTime() -
                          state.fechaHasta.getTimezoneOffset() * 60000
                      ).toISOString()
                    : null,
                },
              }
            );
            let fcnt=[]
            // armo el registro y lo inserto
            resultado.data.registros.forEach((reg) => {
              if (reg.lecturas.length>0){
                fcnt.push(reg.fcnt)
              }
              reg.lecturas.forEach((lectura) => {
                if (lectura?.valor) {
                  if (!datos[disp.numeroSerie].hasOwnProperty(lectura.variableId)) {
                    //
                    datos[disp.numeroSerie][lectura.variableId] = {};
                    datos[disp.numeroSerie][lectura.variableId]["valores"] = {};
                    datos[disp.numeroSerie][lectura.variableId]["nombreVariable"] =
                      lectura.nombreVariable;
                    datos[disp.numeroSerie][lectura.variableId]["id"] =
                      lectura["_id"];
                    datos[disp.numeroSerie][lectura.variableId]["unidadMedida"] =
                      lectura["unidadMedida"];
                    datos[disp.numeroSerie][lectura.variableId]["numeroSerie"] =
                      reg["numeroSerie"];
                    datos[disp.numeroSerie][lectura.variableId][
                      "ultima_lectura"
                    ] = {
                      auditoria: reg.auditoria,
                      valor: lectura.valor
                    };
                  }
                  //
                  datos[disp.numeroSerie][lectura.variableId]["valores"][
                    reg.auditoria
                  ] = lectura.valor;
                  if (lectura.nombreVariable==="Movimiento"){
                    datos[disp.numeroSerie][lectura.variableId]["fcnt"]= fcnt;
                  }
                }
              });
            });
        }}
      if (nSerie!==null){
        dispatch({
          type: OBTENER_REGISTROS_HISTORICO,
          payload: datos,
        });
      }
      else if (disp.numeroSerie!==null){
        dispatch({
          type: OBTENER_REGISTROS_HISTORICO,
          payload: datos,
        }); 
        dispatch({
          type: OBTENER_REGISTROS,
          payload: datos,
        });}
      else{
      dispatch({
        type: OBTENER_REGISTROS,
        payload: datos,
      });
    }
      /*return {
                data: resultado2.data.variables,
                page: resultado2.data.pagina - 1,
                totalCount: resultado2.data.totalRegistros
            } */
    } catch (error) {
      console.log(error)
      const alerta = {
        msg: error,
        categoria: "error",
      };
      dispatch({
        type: REGISTROS_ERROR,
        payload: alerta,
      });
    }
  };
  // muestra un error de validacion
  const errorRegistro = (msj, categoria) => {
    const alerta = {
      msg: msj,
      categoria: categoria,
    };
    dispatch({
      type: REGISTROS_ERROR,
      payload: alerta,
    });
  };

  // actualiza las fechas desde hasta del filtro
  const actualizarFechas = (fechaDesde, fechaHasta) => {
    dispatch({
      type: ACTUALIZAR_FECHAS,
      payload: { fechaDesde, fechaHasta },
    });
  };
  return (
    <RegistroContext.Provider
      value={{
        registros: state.registros,
        registrosHistoricos: state.registrosHistoricos,
        mensaje: state.mensaje,
        fechaDesde: state.fechaDesde,
        fechaHasta: state.fechaHasta,
        obtenerRegistros,
        errorRegistro,
        actualizarFechas,
      }}
    >
      {props.children}
    </RegistroContext.Provider>
  );
};
export default RegistroState;
